import { ENUMS } from 'components/Enum/enums';
import HealthSystemInput from 'components/HealthSystemInput';
import LocationInput from 'components/LocationInput';
import MspInput from 'components/MspInput';
import VmsTypeInput from 'components/VmsTypeInput';
import React from 'react';
import { Edit, SimpleForm, NumberInput, BooleanInput, SelectInput } from 'react-admin';
import { choicesFromEnum } from 'utils/helpers';

const LocalRateRulesEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <SimpleForm>
      <VmsTypeInput />
      <MspInput />
      <HealthSystemInput />
      <LocationInput />
      <BooleanInput source="local_okay" defaultValue={true} />
      <SelectInput
        emptyText=""
        source="applies_to"
        choices={choicesFromEnum(ENUMS.LocalRateRule.applies_to)}
      />
      <NumberInput source="mileage_cutoff" />
      <SelectInput
        source="rate_origin"
        choices={choicesFromEnum(ENUMS.LocalRateRule.rate_origin)}
      />
      <NumberInput source="offset_amount_cents" />
      <NumberInput source="offset_percentage" />
      <BooleanInput source="force_draft" />
    </SimpleForm>
  </Edit>
);

export default LocalRateRulesEdit;
